import { useGetData, useToggleStatusMutation } from "@/services";
import { MasterModuleLayout, useMasterModule } from "../Common";

const IncidentType = () => {
  const masterHook = useMasterModule({
    queryKey: "incident-types",
    idKey: "incidentTypeId",
    nameKey: "incidentType",
    useGetDataQuery: useGetData,
    useToggleStatusMutation: useToggleStatusMutation,
    module: "incident-types",
    statusSuccessMessage: "Incident Type Status Updated Successfully",
  });

  return <MasterModuleLayout title="Incident Types" hookResult={masterHook} />;
};

export default IncidentType;
